import { FC } from 'react';
import { FormState, UseFormRegister } from 'react-hook-form';

import {
  useContractListStore,
  useContractRegistrationStore,
} from 'page/CustomerPage/hooks';
import { ContractFormFields } from 'page/CustomerPage/types/contractFormField';
import { InputModalView } from 'page/CustomerPage/components/ContractRegistrationModal/InputModalView';

type Props = {
  formState: FormState<ContractFormFields>;
  register: UseFormRegister<ContractFormFields>;
  handleClose: () => void;
  handleClickGoConfirmation: () => void;
};

export const InputModal: FC<Props> = ({
  formState,
  register,
  handleClose,
  handleClickGoConfirmation,
}) => {
  const {
    isOpenInputModal,
    startDate,
    endDate,
    changeStartDate,
    changeEndDate,
  } = useContractRegistrationStore();
  const { uncontractedMenus } = useContractListStore();

  /** 確認ボタンの非活性状態 */
  const isButtonDisabled = !formState.isValid || !startDate || !endDate;

  return (
    <>
      {/* 入力モーダル */}
      <InputModalView
        formState={formState}
        isOpen={isOpenInputModal}
        isButtonDisabled={isButtonDisabled}
        startDate={startDate}
        endDate={endDate}
        uncontractedMenus={uncontractedMenus}
        register={register}
        changeStartDate={changeStartDate}
        changeEndDate={changeEndDate}
        handleClose={handleClose}
        handleClickGoConfirmation={handleClickGoConfirmation}
      />
    </>
  );
};
